import { useEffect, useState } from 'react';
import { ImageOff, Loader2 } from 'lucide-react';
import { apiRequest } from '@/lib/apiRequest';

interface Props {
  path: string; // relative to /api, e.g. /watchlist/brand-profiles/{id}/reference-logos/{assetId}/image
  alt?: string;
  style?: React.CSSProperties;
  className?: string;
}

// A plain <img src="/api/..."> can't carry our Authorization header, so
// every authenticated image in this module is fetched as a blob and shown
// via an object URL instead — the one shared place that does this, rather
// than every call site re-inventing the fetch+revoke lifecycle.
export function BlobImage({ path, alt = '', style, className }: Props) {
  const [objectUrl, setObjectUrl] = useState<string | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let currentUrl: string | null = null;
    let cancelled = false;
    setFailed(false);
    setObjectUrl(null);

    apiRequest<Blob>(path, { responseType: 'blob' })
      .then((blob) => {
        if (cancelled) return;
        currentUrl = URL.createObjectURL(blob);
        setObjectUrl(currentUrl);
      })
      .catch(() => { if (!cancelled) setFailed(true); });

    return () => {
      cancelled = true;
      if (currentUrl) URL.revokeObjectURL(currentUrl);
    };
  }, [path]);

  if (failed) {
    return <div className={className} style={{ ...style, display: 'flex', alignItems: 'center', justifyContent: 'center' }}><ImageOff size={18} style={{ color: '#3A5A7A' }} /></div>;
  }
  if (!objectUrl) {
    return <div className={className} style={{ ...style, display: 'flex', alignItems: 'center', justifyContent: 'center' }}><Loader2 size={16} className="animate-spin" style={{ color: '#5A7A9A' }} /></div>;
  }
  return <img src={objectUrl} alt={alt} style={style} className={className} />;
}
